/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import {
  ArrowRightLeft,
  Box,
  CheckCircle2,
  Clock,
  Copy,
  Globe,
  Hash,
  Search,
  Server,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { db } from '../config/firebaseConfig';
import FirestoreTimestampToDate from './utils/FirebaseTimetoDate';

const CopyButton = ({ text, className = '' }) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      navigator.clipboard.writeText(text);
      toast.success('Copied successfully');
    }}
    className={`p-1 hover:bg-white/10 rounded transition-colors group ${className}`}
    title="Copy to clipboard"
  >
    <Copy
      size={12}
      className="text-white/40 group-hover:text-white/80 transition-colors"
    />
  </button>
);

const EtherScan = ({ embedded = false }) => {
  const [id, setId] = useState(localStorage.getItem('roomId') || '');
  const [transactions, setTransactions] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [activeTab, setActiveTab] = useState('blocks'); // "blocks" or "transactions"
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchTransactions = async () => {
      if (!id) return;
      try {
        const transactionsCollection = db
          .collection('rooms')
          .doc(id)
          .collection('transactions');
        const snapshot = await transactionsCollection.get();
        const transactionsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          timestamp: FirestoreTimestampToDate(doc.data().timestamp),
          validate: doc.data().validatedAt
            ? FirestoreTimestampToDate(doc.data().validatedAt)
            : 'Not Validated',
          id: doc.id,
          rawTimestamp: doc.data().timestamp.toString(),
        }));
        setTransactions(transactionsData);
      } catch (error) {
        console.error('Error fetching transactions:', error);
      }
    };

    fetchTransactions();
  }, [id]);

  useEffect(() => {
    const fetchBlocks = async () => {
      if (!id) return;
      try {
        const blocksCollection = db
          .collection('rooms')
          .doc(id)
          .collection('blocks');
        const snapshot = await blocksCollection.get();
        const blocksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          timestamp: FirestoreTimestampToDate(doc.data().created_at),
          id: doc.id,
          rawTimestamp: doc.data().timestamp?.toString() || '',
        }));
        setBlocks(blocksData);
      } catch (error) {
        console.error('Error fetching blocks:', error);
      }
    };

    fetchBlocks();
  }, [id]);

  const filteredBlocks = blocks.filter(
    (b) =>
      b.hash?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      b.id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredTransactions = transactions.filter(
    (t) =>
      t.hash?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.sender?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.receiver?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section
      className={embedded ? 'p-0' : 'min-h-screen pt-8 pb-12 px-6 bg-[#0B0E14]'}
    >
      <div className={embedded ? '' : 'max-w-[95vw] mx-auto space-y-8'}>
        {/* Header */}
        {!embedded && (
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                <Globe className="text-[#6C4FFF]" size={32} />
                Network Explorer
              </h1>
              <p className="text-white/40">
                Real-time visualization of the blockchain network, blocks, and
                transaction history.
              </p>
            </div>

            {/* Search Bar */}
            <div className="relative group max-w-2xl">
              <Search
                className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40 group-focus-within:text-[#6C4FFF] transition-colors"
                size={18}
              />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by Address, Tx Hash, Block, or Token..."
                className="w-full bg-[#1E2330] border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-white text-sm outline-none focus:border-[#6C4FFF] focus:ring-1 focus:ring-[#6C4FFF] transition-all placeholder:text-white/30"
              />
            </div>
          </div>
        )}

        {/* Tab Navigation */}
        <div className="flex items-center gap-2 border-b border-white/5">
          <button
            onClick={() => setActiveTab('blocks')}
            className={`flex items-center gap-2 px-6 py-3 border-b-2 text-sm font-semibold transition-all ${
              activeTab === 'blocks'
                ? 'border-[#6C4FFF] text-white'
                : 'border-transparent text-white/40 hover:text-white hover:border-white/10'
            }`}
          >
            <Box size={16} />
            Recent Blocks
            <span className="bg-white/10 text-white/60 text-[10px] px-2 py-0.5 rounded-full">
              {blocks.length}
            </span>
          </button>
          <button
            onClick={() => setActiveTab('transactions')}
            className={`flex items-center gap-2 px-6 py-3 border-b-2 text-sm font-semibold transition-all ${
              activeTab === 'transactions'
                ? 'border-[#6C4FFF] text-white'
                : 'border-transparent text-white/40 hover:text-white hover:border-white/10'
            }`}
          >
            <ArrowRightLeft size={16} />
            Transactions
            <span className="bg-white/10 text-white/60 text-[10px] px-2 py-0.5 rounded-full">
              {transactions.length}
            </span>
          </button>
        </div>

        {/* Content */}
        <div className="bg-[#1E2330]/50 backdrop-blur rounded-2xl border border-white/5 overflow-hidden shadow-xl min-h-[500px]">
          {/* Blocks Table */}
          {activeTab === 'blocks' && (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-white/5 bg-white/[0.02]">
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider w-[10%]">
                      Block
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider w-[15%]">
                      Time
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider w-[25%]">
                      Hash
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider w-[25%]">
                      Prev Hash
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider w-[25%]">
                      Transactions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/5">
                  {filteredBlocks.length > 0 ? (
                    filteredBlocks.map((block, index) => (
                      <tr
                        key={index}
                        className="hover:bg-white/[0.02] transition-colors group"
                      >
                        <td className="py-4 px-6">
                          <div className="flex items-center gap-2">
                            <span className="bg-[#6C4FFF]/10 text-[#6C4FFF] px-2 py-1 rounded text-xs font-semibold font-mono">
                              #{blocks.length - index - 1}
                            </span>
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex items-center gap-2 text-white/60 text-xs">
                            <Clock size={12} />
                            {block.timestamp}
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex items-center gap-1">
                            <span className="text-white font-mono text-xs">
                              {block.hash?.substring(0, 16)}...
                            </span>
                            <CopyButton text={block.hash} />
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          {block.previousBlockHash ? (
                            <div className="flex items-center gap-1">
                              <span className="text-white/60 font-mono text-xs">
                                {block.previousBlockHash?.substring(0, 16)}...
                              </span>
                              <CopyButton text={block.previousBlockHash} />
                            </div>
                          ) : (
                            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 rounded-full text-[10px] font-medium uppercase tracking-wide">
                              <Server size={10} /> Genesis
                            </span>
                          )}
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex flex-col gap-1.5">
                            {block.transactions &&
                            block.transactions.length > 0 ? (
                              <>
                                <span className="text-white/40 text-[10px] font-bold uppercase">
                                  {block.transactions.length} Txns
                                </span>
                                <div className="flex gap-1 overflow-x-auto pb-1 scrollbar-none">
                                  {block.transactions
                                    .slice(0, 3)
                                    .map((t, i) => (
                                      <span
                                        key={i}
                                        className="bg-black/20 text-white/50 px-1.5 py-0.5 rounded text-[10px] font-mono border border-white/5"
                                        title={t.hash}
                                      >
                                        {t.hash?.substring(0, 4)}..
                                      </span>
                                    ))}
                                  {block.transactions.length > 3 && (
                                    <span className="bg-black/20 text-white/50 px-1.5 py-0.5 rounded text-[10px] border border-white/5">
                                      +{block.transactions.length - 3}
                                    </span>
                                  )}
                                </div>
                              </>
                            ) : (
                              <span className="text-white/20 text-xs italic">
                                Empty Block
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="py-16 text-center">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center">
                            <Box className="text-white/20" size={24} />
                          </div>
                          <p className="text-white/40 text-sm">
                            No blocks found matching your search
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Transactions Table */}
          {activeTab === 'transactions' && (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-white/5 bg-white/[0.02]">
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      Tx Hash
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      Time
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      From
                    </th>
                    <th className="text-left py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      To
                    </th>
                    <th className="text-right py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      Value
                    </th>
                    <th className="text-center py-4 px-6 text-white/40 text-xs font-bold uppercase tracking-wider">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/5">
                  {filteredTransactions.length > 0 ? (
                    filteredTransactions.map((transaction, index) => (
                      <tr
                        key={index}
                        className="hover:bg-white/[0.02] transition-colors"
                      >
                        <td className="py-4 px-6">
                          <div className="flex flex-col gap-1">
                            <div className="flex items-center gap-1">
                              <Hash size={12} className="text-[#6C4FFF]" />
                              <span className="text-[#6C4FFF] font-mono text-sm">
                                {transaction.hash?.substring(0, 14)}...
                              </span>
                              <CopyButton text={transaction.hash} />
                            </div>
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <div className="text-white/60 text-xs whitespace-nowrap">
                            {transaction.timestamp}
                          </div>
                          {transaction.validatedAt && (
                            <div className="text-white/20 text-[10px] mt-0.5">
                              Validated: {transaction.validate}
                            </div>
                          )}
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex items-center gap-1 group/addr">
                            <span className="text-white/80 font-mono text-xs">
                              {transaction.sender?.substring(0, 8)}...
                            </span>
                            <CopyButton text={transaction.sender} />
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex items-center gap-1 group/addr">
                            <span className="text-white/80 font-mono text-xs">
                              {transaction.receiver?.substring(0, 8)}...
                            </span>
                            <CopyButton text={transaction.receiver} />
                          </div>
                        </td>
                        <td className="py-4 px-6 text-right">
                          <span className="text-white font-bold">
                            {transaction.amount}
                          </span>{' '}
                          <span className="text-white/40 text-xs">AST</span>
                        </td>
                        <td className="py-4 px-6 text-center">
                          <span
                            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold border uppercase tracking-wider ${
                              transaction.status === 'Verified' ||
                              transaction.status === 'Validate' ||
                              transaction.status === 'Added to block' ||
                              transaction.status === 'Added to chain'
                                ? 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400'
                                : 'bg-amber-500/10 border-amber-500/20 text-amber-400'
                            }`}
                          >
                            {transaction.status === 'Verified' ||
                            transaction.status === 'Validate' ||
                            transaction.status === 'Added to block' ||
                            transaction.status === 'Added to chain' ? (
                              <CheckCircle2 size={10} />
                            ) : (
                              <Clock size={10} />
                            )}
                            {transaction.status}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="py-16 text-center">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center">
                            <ArrowRightLeft
                              className="text-white/20"
                              size={24}
                            />
                          </div>
                          <p className="text-white/40 text-sm">
                            No transactions found matching your search
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default EtherScan;
